import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { GridComponent, Inject, ColumnsDirective, ColumnDirective, Page, Group } from '@syncfusion/ej2-react-grids';
//import { data } from './datasource'; 
import { L10n } from '@syncfusion/ej2-base';
import deDELocalization from './es-ES.json'
L10n.load(deDELocalization);
function Tabla() {
    const data = 
               
        [
            {
                "OrderID": 1,
                "CustomerID": "C001",
                "ShipCity": "New York",
                "ShipName": "Fast Shipping Co."
            },
            {
                "OrderID": 2,
                "CustomerID": "C002",
                "ShipCity": "Los Angeles",
                "ShipName": "Quick Deliveries Inc."
            },
            {
                "OrderID": 3,
                "CustomerID": "C003",
                "ShipCity": "Chicago",
                "ShipName": "Express Freight Ltd."
            },
            {
                "OrderID": 4,
                "CustomerID": "C004",
                "ShipCity": "Houston",
                "ShipName": "Speedy Shipping LLC"
            },
            {
                "OrderID": 5,
                "CustomerID": "C005",
                "ShipCity": "Phoenix",
                "ShipName": "Swift Couriers"
            },
            {
                "OrderID": 6,
                "CustomerID": "C006",
                "ShipCity": "Philadelphia",
                "ShipName": "Rapid Transit Corp."
            },
            {
                "OrderID": 7,
                "CustomerID": "C007",
                "ShipCity": "San Antonio",
                "ShipName": "On-Time Deliveries"
            },
            {
                "OrderID": 8,
                "CustomerID": "C008",
                "ShipCity": "San Diego",
                "ShipName": "Reliable Shipping Services"
            },
            {
                "OrderID": 9,
                "CustomerID": "C009",
                "ShipCity": "Dallas",
                "ShipName": "Efficient Shipments"
            },
            {
                "OrderID": 10,
                "CustomerID": "C010",
                "ShipCity": "San Jose",
                "ShipName": "Timely Deliveries"
            },
            {
                "OrderID": 11,
                "CustomerID": "C011",
                "ShipCity": "Austin",
                "ShipName": "Premier Logistics"
            },
            {
                "OrderID": 12,
                "CustomerID": "C012",
                "ShipCity": "Jacksonville",
                "ShipName": "Fast Lane Freight"
            },
            {
                "OrderID": 13,
                "CustomerID": "C013",
                "ShipCity": "San Francisco",
                "ShipName": "Velocity Couriers"
            },
            {
                "OrderID": 14,
                "CustomerID": "C014",
                "ShipCity": "Indianapolis",
                "ShipName": "Express Delivery Services"
            },
            {
                "OrderID": 15,
                "CustomerID": "C015",
                "ShipCity": "Columbus",
                "ShipName": "Direct Shipments"
            },
            {
                "OrderID": 16,
                "CustomerID": "C016",
                "ShipCity": "Fort Worth",
                "ShipName": "Quick Ship Solutions"
            },
            {
                "OrderID": 17,
                "CustomerID": "C017",
                "ShipCity": "Charlotte",
                "ShipName": "Expedited Freight"
            },
            {
                "OrderID": 18,
                "CustomerID": "C018",
                "ShipCity": "Detroit",
                "ShipName": "Fast Track Shipping"
            },
            {
                "OrderID": 19,
                "CustomerID": "C019",
                "ShipCity": "El Paso",
                "ShipName": "Prompt Delivery"
            },
            {
                "OrderID": 20,
                "CustomerID": "C020",
                "ShipCity": "Memphis",
                "ShipName": "Rapid Express"
            }
        ]
        
            
    
    const pageOptions = { pageSize: 7 };
    return (<GridComponent dataSource={data} locale='de-DE' allowPaging={true} pageSettings={pageOptions} allowGrouping={true}>
        <ColumnsDirective>
            <ColumnDirective field='OrderID' headerText='Order ID' width='120' textAlign="Center"></ColumnDirective>
            <ColumnDirective field='CustomerID' headerText='Customer ID' width='150'></ColumnDirective>
            <ColumnDirective field='ShipCity' headerText='Ship City' width='150'></ColumnDirective>
            <ColumnDirective field='ShipName' headerText='Ship Name' width='150'></ColumnDirective>
        </ColumnsDirective>
        <Inject services={[Page, Group]}/>
    </GridComponent>);
}
;
export default Tabla; 